/** Single-entry memoizer keyed on `(extent, resolution, projection)`. */
export class RenderCache {
    x0_ = 0;
    y0_ = 0;
    x1_ = 0;
    y1_ = 0;
    resolution_ = 0;
    projKey_ = '';
    value_;
    has_ = false;
    /** Return cached value when key matches; otherwise compute and cache. */
    get(extent, resolution, projection, compute) {
        const projKey = typeof projection === 'string'
            ? projection
            : (projection?.getCode() ?? '');
        if (this.has_ &&
            this.resolution_ === resolution &&
            this.projKey_ === projKey &&
            Math.abs(this.x0_ - extent[0]) < resolution &&
            Math.abs(this.y0_ - extent[1]) < resolution &&
            Math.abs(this.x1_ - extent[2]) < resolution &&
            Math.abs(this.y1_ - extent[3]) < resolution) {
            return this.value_;
        }
        const value = compute();
        this.x0_ = extent[0];
        this.y0_ = extent[1];
        this.x1_ = extent[2];
        this.y1_ = extent[3];
        this.resolution_ = resolution;
        this.projKey_ = projKey;
        this.value_ = value;
        this.has_ = true;
        return value;
    }
    /** Drop the cached entry. */
    invalidate() {
        this.has_ = false;
    }
}
//# sourceMappingURL=renderCache.js.map